import { networkStatusFor } from 'actions/network/actions'
import config from 'config'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { RootState } from 'stores'
import { IAnswer } from 'types/IAnswer'
import { IDemographics } from 'types/IDemographics'
import { IScore } from 'types/IScore'
import { NetworkError } from 'types/networkError'
import { uploadData } from './actions'

export function* watchForUpload() {
  yield takeLatest(uploadData.toString(), uploadToFirebase)
}

function* uploadToFirebase() {
  // Set network status to loading while we do calculations
  yield put(networkStatusFor('upload')('loading'))

  // Get data from state
  const { demographics, answers } = yield select((state: RootState) => state)  

  const dataToUpload: IDemographics & IScore = {
    ...demographics,
    conservatismScore: config.getScoreFor(answers, 'conservatism'),
    populismScore: config.getScoreFor(answers, 'populism'),
    answers
  }

  // Try to upload
  // @todo Could be rewritten using "retry" from redux-saga
  try {
    yield call(postReaderAnswer, dataToUpload)
    yield put(networkStatusFor('upload')('success'))
  } catch (e) {
    if (e instanceof NetworkError) {
      yield put(networkStatusFor('upload')(e.status))
    }
    throw e
  }
}

function postReaderAnswer(dataToUpload: IDemographics & IScore) {
  return window
    .fetch(config.dbEndpoint + '/.json', {
      body: JSON.stringify(dataToUpload),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })
    .then(response => {
      if (response.ok) {
        return response.json()
      }
      throw new NetworkError(response.statusText, response.status)
    })
}
